<template>
    <div class="daily-sales-report card fts-table-wrapper">
        <div class="card-body">
            <div class="header-row">
                <h3 class="daily-sales-report-header">Sales Report</h3>
                <button class="btn btn-primary btn-run-report" :disabled="dataChanged == false || carriersErrorMsg != '' || dateErrorMsg != ''" @click="runReport()">Run Report</button>
            </div>
            <div class="date-config">
                <div class="date-ranges-box">
                    <div class="date-range-box">
                        <h6>Start Date</h6>
                        <date-picker v-model="startDate" @change="changedDate()" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    </div>
                    <div class="date-range-box">
                        <h6>End Date</h6>
                        <date-picker v-model="endDate" @change="changedDate()" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    </div>
                    <span v-if="dateErrorMsg != ''" class="error-message">{{dateErrorMsg}}</span>
                </div>
            </div>
            <div class="carriers-config">
                <h3 class="carriers-config-header">Carrier <span>select carrier</span></h3>
                <div class="carriers-box">
                    <div class="carrier-box">
                        <label :class="carriers.simon ? '' : 'gray-out'" for="simonCarrier">
                            <input v-model="carriers.simon" type="checkbox" id="simonCarrier" @change="carrierChanged()"/>
                            <span class="checkbox"></span>
                            <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/darklogo.svg" class="dark-mode" alt="">
                        </label>
                    </div>
                    <div class="carrier-box">
                        <label :class="carriers.tmobile ? '' : 'gray-out'" for="tmobileCarrier">
                            <input v-model="carriers.tmobile" type="checkbox" id="tmobileCarrier" @change="carrierChanged()"/>
                            <span class="checkbox"></span>
                            <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                            <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div class="carrier-box">
                        <label :class="carriers.vodafone ? '' : 'gray-out'" for="vodafoneCarrier">
                            <input v-model="carriers.vodafone" type="checkbox" id="vodafoneCarrier" @change="carrierChanged()"/>
                            <span class="checkbox"></span>
                            <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div class="carrier-box">
                        <label :class="carriers.kore ? '' : 'gray-out'" for="koreCarrier">
                            <input v-model="carriers.kore" type="checkbox" id="koreCarrier" @change="carrierChanged()"/>
                            <span class="checkbox"></span>
                            <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/kore-logo.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div v-if="carriersErrorMsg != ''" class="error-message">{{carriersErrorMsg}}</div>
                </div>
            </div>
            <div class="display-cards">
                <div class="display-cards-box">
                    <div class="display-card">
                        <h3>{{activated}}</h3>
                        <h4>Activated SIM's</h4>
                    </div>
                    <div class="display-card">
                        <h3>{{activatedRevenueImpact}}</h3>
                        <h4>Activated Monthly Revenue</h4>
                    </div>
                    <div class="display-card">
                        <h3>{{deactivated}}</h3>
                        <h4>Deactivated SIMs</h4>
                    </div>
                    <div class="display-card">
                        <h3>{{deactivatedRevenueImpact}}</h3>
                        <h4>Deactivated Monthly Revenue</h4>
                    </div>
                </div>
            </div>
            <div class="table-box">
                <div class="filter-row">
                    <div class="left-side">
                        <div class="search-box">
                            <b-form-group>
                                <b-input-group>
                                    <input type="text" class="form-control"  v-model="filter" @disabled="loading" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                                </b-input-group>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="size-page-wrapper text-right">
                        <button class="btn btn-primary export-sale-report-btn" @click="openExportModal()">Export Sale Report</button>
                        <label for="size-page">Display:</label>
                        <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                            <option value="40">40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                <div class="fts-table table-responsive-sm daily-sales-reports-table-box">
                    <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi table-managment fts-table daily-sales-reports-table">
                        <thead role="rowgroup">
                            <tr role="row">
                                <th v-on:click="changeSort(1)" role="columnheader" :aria-sort="setAreaSort(1)">Company Name</th>
                                <th v-on:click="changeSort(2)" role="columnheader" :aria-sort="setAreaSort(2)">Plan</th>
                                <th v-on:click="changeSort(3)" role="columnheader" :aria-sort="setAreaSort(3)">Carrier</th>
                                <th v-on:click="changeSort(4)" role="columnheader" :aria-sort="setAreaSort(4)">MRC</th>
                                <th v-on:click="changeSort(5)" role="columnheader" :aria-sort="setAreaSort(5)">Net Sim Activity</th>
                                <th v-on:click="changeSort(6)" role="columnheader" :aria-sort="setAreaSort(6)">Revenue Impact</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item in list">
                                <td>{{item.companyName}}</td>
                                <td>{{item.ratePlanName}}</td>
                                <td>{{item.carrierName}}</td>
                                <td>{{item.mrc}}</td>
                                <td>{{item.netSimActivity}}</td>
                                <td :class="item.positiveImpact ? 'green' : 'orange' "><i :class="['fa', item.positiveImpact ? 'fa-arrow-circle-o-up' : 'fa-arrow-circle-o-down']"></i>{{item.revenueImpact}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="no-data" v-if="loading == false && noData == true">
                        <h2 class="text">You have no data</h2>
                    </div>
                </div>
                <div class="fts-bottom-table fts-bottom-table-centered bottom-table-daily-sales-report">
                    <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                        <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                    </nav>
                </div>
            </div>

            <div class="loader-daily-sales-list" v-if="loading && noData == false">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>
                <h2 class="text">Daily sales report is loading</h2>
            </div>
        </div>
        <b-modal size="md" ref="selectExportFormat" id="selectExportFormat" centered hide-header hide-footer>
            <i class="fa fa-close" @click="closeExportModal"></i>
            <img src="../../assets/img/file-format.svg">
            <h3>Save export file as:</h3>
            <div>
                <button class="btn btn-primary csv" v-on:click="exportCsv()">CSV</button>
                <button class="btn btn-primary xls" v-on:click="exportXlsx()">XLSX</button>
            </div>
            <button class="btn btn-light" @click="closeExportModal()">Cancel</button>
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import Paginate from 'vuejs-paginate'
    import globalStore from "../../variables";
    import Axios from 'axios'

    export default {
        name: "DailySalesReport",
        components: {
            DatePicker,
            Paginate
        },
        data() {
            return {
                startDate: null,
                endDate: null,
                initialData: {
                    startDate: null,
                    endDate: null,
                    carriers: {
                        simon: true,
                        tmobile: true,
                        vodafone: true
                    }
                },
                dateErrorMsg: '',
                carriersErrorMsg: '',
                dataChanged: false,
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                carriers: {
                    simon: true,
                    tmobile: true,
                    vodafone: true,
                    kore: true
                },
                sortSettings: {
                    page: 1,
                    size: 40,
                    desc: false,
                    sort: 1
                },
                paginationCount: 3,
                loading: false,
                noData: false,
                filter: '',
                searchString: '',
                timerSearch: null,
                list: [],
                activated: null,
                activatedRevenueImpact: null,
                deactivated: null,
                deactivatedRevenueImpact: null
            }
        },
        methods: {
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getDailySalesReports(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            sizePage() {
                this.getDailySalesReports(true);
            },
            searchKeyUp() {
                clearTimeout(this.timerSearch)
                this.timerSearch = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.timerSearch)
            },
            searchRow() {
                this.searchString = '&search=' + escape(this.filter);
                this.getDailySalesReports(true)
            },
            paginationControll(ev) {
                this.sortSettings.page = ev;
                this.getDailySalesReports(false);
            },
            changedDate() {
                let today = new Date();
                today = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);

                if (this.startDate == '' || this.endDate == '') {
                    this.dateErrorMsg = 'You need to pick both dates.'
                    return false
                } else if (this.endDate < this.startDate) {
                    this.dateErrorMsg = 'End date must be later than start date.'
                    return false
                } else if (this.startDate > today || this.endDate > today) {
                    this.dateErrorMsg = 'Dates can not be from the future.'
                    return false
                } else {
                    this.dateErrorMsg = ''
                    this.blockRunReport();
                }
            },
            carrierChanged() {
                if (this.carriers.simon == false && this.carriers.tmobile == false && this.carriers.vodafone == false && this.carriers.kore == false) {
                    this.carriersErrorMsg = 'At least one carrier needs to be selected.'
                    return false
                } else {
                    this.carriersErrorMsg = ''
                    this.blockRunReport();
                }
            },
            blockRunReport() {
                if (this.initialData.startDate == this.startDate && this.initialData.endDate == this.endDate && this.initialData.carriers.simon == this.carriers.simon &&this.initialData.carriers.tmobile == this.carriers.tmobile && this.initialData.carriers.vodafone == this.carriers.vodafone && this.initialData.carriers.kore == this.carriers.kore) {
                    this.dataChanged = false
                } else {
                    this.dataChanged = true
                }
            },
            runReport() {
                this.getDailySalesReports(true)
                this.getSummary()
            },
            getDailySalesReports(resetPage) {
                this.loading = true
                this.noData = false
                if (resetPage) {
                    this.sortSettings.page = 1
                }
                let carriers = ''
                if (this.carriers.simon) {
                    carriers = carriers + '&carrierIds=1'
                }
                if (this.carriers.tmobile) {
                    carriers = carriers + '&carrierIds=2'
                }
                if (this.carriers.vodafone) {
                    carriers = carriers + '&carrierIds=3'
                }
                if (this.carriers.kore) {
                    carriers = carriers + '&carrierIds=4'
                }

                Axios.get(`${globalStore.data.restApiUrl}/daily-sales-report/page-count?size=${this.sortSettings.size}&startDate=${this.startDate}&endDate=${this.endDate}${carriers}${this.searchString}`)
                    .then(response => {
                        this.paginationCount = response.data
                        this.initialData = {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            carriers: {
                                simon: this.carriers.simon,
                                tmobile: this.carriers.tmobile,
                                vodafone: this.carriers.vodafone,
                                kore: this.carriers.kore
                            }
                        }
                        this.dataChanged = false
                    })
                    .catch(error => {
                        console.log(error)
                    })


                Axios.get(`${globalStore.data.restApiUrl}/daily-sales-report/list?page=${this.sortSettings.page}&size=${this.sortSettings.size}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}&startDate=${this.startDate}&endDate=${this.endDate}${carriers}${this.searchString}`)
                    .then(response => {
                        this.noData = false
                        this.list = []
                        for (let row of response.data) {
                            let template = {}
                            template.companyName = row.companyName
                            template.ratePlanName = row.ratePlanName ? row.ratePlanName : 'N/A'
                            template.carrierName = row.carrierName
                            template.mrc = row.mrc ? '$ ' + row.mrc.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}) : 'N/A'
                            template.netSimActivity = row.netSimActivity
                            template.revenueImpact = row.revenueImpact ? '$ ' + row.revenueImpact.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}) : 'N/A'
                            template.positiveImpact = row.revenueImpact > 0 ? true : false
                            this.list.push(template)
                        }
                        if (this.list.length == 0) {
                            this.noData = true
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            getSummary() {
                let carriers = ''
                if (this.carriers.simon) {
                    carriers = carriers + '&carrierIds=1'
                }
                if (this.carriers.tmobile) {
                    carriers = carriers + '&carrierIds=2'
                }
                if (this.carriers.vodafone) {
                    carriers = carriers + '&carrierIds=3'
                }
                if (this.carriers.vodafone) {
                    carriers = carriers + '&carrierIds=4'
                }
                Axios.get(`${globalStore.data.restApiUrl}/daily-sales-report/summary?startDate=${this.startDate}&endDate=${this.endDate}${carriers}`)
                    .then(response => {
                        this.activated = response.data.activated ? response.data.activated : 0
                        this.activatedRevenueImpact = response.data.activatedRevenueImpact ? '$ ' + response.data.activatedRevenueImpact.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}) : '$ 0.00'
                        this.deactivated = response.data.deactivated ? response.data.deactivated : 0
                        this.deactivatedRevenueImpact = response.data.deactivatedRevenueImpact ? '$ ' + response.data.deactivatedRevenueImpact.toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}) : '$ 0.00'
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            openExportModal() {
                this.$refs['selectExportFormat'].show()
            },
            closeExportModal() {
                this.$refs['selectExportFormat'].hide()
            },
            exportCsv() {
                this.$refs['selectExportFormat'].hide()


                if (this.dateErrorMsg != '' || this.carriersErrorMsg != '') {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Sales report error',
                        text: 'Please, fix all errors before exporting report.',
                        duration: 3000,
                    });
                    return false
                }

                let carriers = ''
                if (this.carriers.simon) {
                    carriers = carriers + '&carrierIds=1'
                }
                if (this.carriers.tmobile) {
                    carriers = carriers + '&carrierIds=2'
                }
                if (this.carriers.vodafone) {
                    carriers = carriers + '&carrierIds=3'
                }
                if (this.carriers.kore) {
                    carriers = carriers + '&carrierIds=4'
                }

                Axios.get(globalStore.data.restApiUrl + "/daily-sales-report/csv?startDate=" + this.startDate + "&endDate=" + this.endDate + carriers)
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'Sales Report.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Daily Sales Report error',
                        text: 'Something went wrong exporting Daily Sale. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['selectExportFormat'].hide()

                if (this.dateErrorMsg != '' || this.carriersErrorMsg != '') {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Sales report error',
                        text: 'Please, fix all errors before exporting report.',
                        duration: 3000,
                    });
                    return false
                }

                let carriers = ''
                if (this.carriers.simon) {
                    carriers = carriers + '&carrierIds=1'
                }
                if (this.carriers.tmobile) {
                    carriers = carriers + '&carrierIds=2'
                }
                if (this.carriers.vodafone) {
                    carriers = carriers + '&carrierIds=3'
                }
                if (this.carriers.kore) {
                    carriers = carriers + '&carrierIds=4'
                }

                Axios.get(globalStore.data.restApiUrl + "/daily-sales-report/xlsx?startDate=" + this.startDate + "&endDate=" + this.endDate + carriers, {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'Sales Report.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Daily Sales Report error',
                        text: 'Something went wrong exporting Daily Sale. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            }
        },
        mounted() {
            let today = new Date();
            this.startDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);
            this.endDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);
            this.initialData.startDate = this.startDate
            this.initialData.endDate = this.endDate
            this.getDailySalesReports(false)
            this.getSummary()
        }
    }
</script>

<style lang="scss">
    .daily-sales-report {
        .loader-daily-sales-list {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
        }

        .card-body {
            padding: 0;
        }
        .header-row {
            display: flex;
            justify-content: space-between;
            padding: 20px 20px 0;
            .daily-sales-report-header {
                font-size: 15px;
                font-weight: 700;
            }
        }
        .date-config {
            display: flex;
            align-items: center;
            margin: 0 0 32px;
            padding: 0 20px;
            .date-control {
                font-size: 14px;
                text-transform: uppercase;
                font-weight: 700;
                cursor: pointer;
                &:first-child {
                    margin-right: 30px;
                }
                &.selected {
                    color: #0088FF;
                }
            }
            .date-ranges-box {
                position: relative;
                display: flex;
                .date-range-box {
                    display: flex;
                    flex-direction: column;
                    margin-right: 20px;
                    h6 {
                        margin: 0 0 10px;
                        font-size: 14px;
                        font-weight: 400;
                    }
                    &:last-child {
                        margin: 0;
                    }
                }
                .mx-datepicker {
                    width: 150px;
                }
                .error-message {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    font-size: 12px;
                    color: #FC4D4D;
                }
            }
        }
        .carriers-config {
            width: 340px;
            margin: 0 20px 40px;
            padding: 20px;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            .carriers-config-header {
                margin: 0 0 20px;
                font-size: 15px;
                font-weight: 700;
                span {
                    margin: 0 0 0 20px;
                    font-size: 12px;
                    font-weight: 400;
                }
            }
            .carriers-box {
                position: relative;
                display: flex;
                flex-direction: column;
                .error-message {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    font-size: 12px;
                    color: #FC4D4D;
                }
                label {
                    display: flex;
                    align-items: center;
                    margin: 0 50px 30px 0;
                    cursor: pointer;
                    input {
                        display: none;
                        &+.checkbox {
                            position: relative;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 15px;
                            height: 15px;
                            margin-right: 20px;
                            background-color: #f2f2f2;
                            -webkit-border-radius: 2px;
                            -moz-border-radius: 2px;
                            border-radius: 2px;
                            border: 1px solid #3a4149;
                            text-align: center;
                            font-family: FontAwesome;
                            font-size: 10px;
                        }
                        &:checked {
                            &+.checkbox {
                                &:before {
                                    content: '\f00c';
                                    color: #3a4149;
                                }
                            }
                        }
                    }
                    img {
                        height: 20px;
                        width: auto;
                        &.light-mode {
                            display: initial;
                        }
                        &.dark-mode {
                            display: none;
                        }
                    }

                    &.gray-out {
                        img {
                            opacity: 0.5;
                        }
                    }
                }
            }
        }
        .display-cards {
            padding: 0 20px 50px;
            .display-cards-box {
                display: flex;
                .display-card {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 230px;
                    margin: 0 20px 0 0;
                    padding: 20px;
                    background-color: #f2f2f2;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    h3 {
                        margin: 0 0 9px;
                        font-size: 20px;
                        font-weight: 700;
                    }
                    h4 {
                        margin: 0;
                        font-size: 14px;
                        font-weight: 400;
                    }
                }
            }
        }
        .card {
            .card-body {
                position: relative;
                .filter-row > div {
                    width: initial;
                }
            }
        }

        .table-box {
            .filter-row {
                .left-side {
                    flex-grow: 1;
                    margin-right: 50px;
                    .search-box {
                        min-width: 0;
                        max-width: 345px;
                    }
                }
                .text-right {
                    .export-sale-report-btn {
                        margin-right: 10px;
                    }
                }
            }
            .daily-sales-reports-table-box {
                position: relative;

                .no-data {
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;

                    background-color: rgba(255, 255, 255, 0.7);

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    align-content: center;

                    .sk-wave {
                        height: 60px;
                        .sk-rect {
                            width: 3px;
                            background-color: #39c354;
                            border-radius: 4px;
                        }
                    }

                    h2.text {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: 700;
                    }
                }
            }
            .bottom-table-daily-sales-report {
                position: relative;
                .btn-run-report {
                    position: absolute;
                    right: 20px;
                    top: 20px;
                }
            }
        }
        .daily-sales-reports-table {
            position: relative;

            thead,
            tbody {
                tr {
                    th, td {
                        white-space: nowrap;
                    }
                }
            }

            .no-data {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                background-color: rgba(255, 255, 255, 0.7);

                display: flex;
                justify-content: center;
                align-items: center;
                align-content: center;

                .sk-wave {
                    height: 60px;
                    .sk-rect {
                        width: 3px;
                        background-color: #39c354;
                        border-radius: 4px;
                    }
                }

                h2.text {
                    margin-top: 20px;
                    text-align: center;
                    font-size: 15px;
                    font-weight: 700;
                }
            }

            tbody {
                tr {
                    td {
                        i {
                            margin-right: 12px;
                        }
                        &.orange {
                            i {
                                color: #FF6F00;
                            }
                        }
                        &.green {
                            color: #00B406;
                        }
                    }
                }
            }
        }
    }


    #selectExportFormat___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        i {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 16px;
            cursor: pointer;
        }

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }
    }

    .dark-theme {
        .daily-sales-report {
            background-color: #3a4149;
            color: #fff;
            border-color: #1a1c1d;

            .loader-daily-sales-list {
                background-color: rgba(0,0,0,0.4);
            }

            .table-box {
                .daily-sales-reports-table-box {
                    .no-data {
                        background-color: rgba(0,0,0,0.4);
                    }
                }
            }
            .carriers-config {
                border-color: #1a1c1d;
                .carriers-box {
                    label {
                        img {
                            &.light-mode {
                                display: none;
                            }
                            &.dark-mode {
                                display: initial;
                            }
                        }
                    }
                }
            }
            .display-cards {
                .display-cards-box {
                    .display-card {
                        background-color: #2f353a;
                        border-color: #1a1c1d;
                    }
                }
            }
            .card {
                border: 0;
            }
        }


        #selectExportFormat___BV_modal_body_ {
            background-color: #3a4149;
            color: #ffffff;
        }
    }
</style>
